import React, { useState } from 'react';
import API from '../services/api';

export function GiveShoutOutModal({ isOpen, onClose, teammates = [], onPosted }) {
  const [toUserId, setToUserId] = useState('');
  const [message, setMessage] = useState('');
  const [visibility, setVisibility] = useState('public');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const reset = () => { setToUserId(''); setMessage(''); setVisibility('public'); setError(''); };

  const submit = async () => {
    if (!toUserId || !message.trim()) return;
    setSending(true); setError('');
    try {
      await API.post('/therapist/shout-outs', {
        toUserId: Number(toUserId), message: message.trim(), visibility,
      });
      reset();
      if (onPosted) onPosted();
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to post. Please try again.');
    } finally {
      setSending(false);
    }
  };

  const canSend = toUserId && message.trim() && !sending;

  return (
    <div style={backdrop} onClick={onClose}>
      <div style={modal} onClick={(e) => e.stopPropagation()}>
        <div style={header}>
          <h3 style={{ margin: 0, color: '#fff', fontSize: '1.1rem' }}>💜 Give a shout-out</h3>
          <button onClick={onClose} style={closeBtn}>×</button>
        </div>
        <div style={body}>
          <label style={label}>To</label>
          <select value={toUserId} onChange={(e) => setToUserId(e.target.value)} style={input}>
            <option value="">Choose a teammate…</option>
            {teammates.map((t) => (
              <option key={t.therapist_id} value={t.therapist_id}>
                {t.first_name} {t.last_name}
              </option>
            ))}
          </select>

          <label style={label}>Message</label>
          <textarea
            value={message}
            maxLength={500}
            onChange={(e) => setMessage(e.target.value)}
            rows={4}
            placeholder="What do you appreciate about them?"
            style={{ ...input, resize: 'vertical' }}
          />
          <div style={{ fontSize: 12, color: '#888', textAlign: 'right' }}>{message.length}/500</div>

          <label style={label}>Who can see it?</label>
          <div style={{ display: 'flex', gap: 10 }}>
            <button type="button" onClick={() => setVisibility('public')} style={visibility === 'public' ? toggleOn : toggleOff}>
              Everyone
            </button>
            <button type="button" onClick={() => setVisibility('private')} style={visibility === 'private' ? toggleOn : toggleOff}>
              🔒 Just them
            </button>
          </div>

          {error && <p style={{ color: '#c0392b', fontSize: 13, margin: '10px 0 0' }}>{error}</p>}

          <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
            <button onClick={submit} disabled={!canSend} style={{ ...primaryBtn, opacity: canSend ? 1 : 0.6 }}>
              {sending ? 'Sending…' : 'Send shout-out'}
            </button>
            <button onClick={onClose} style={secondaryBtn}>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  );
}

const backdrop = {
  position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
  display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16,
};
const modal = {
  background: '#fff', borderRadius: 12, width: 'min(460px, 96vw)', maxHeight: '90vh',
  overflow: 'auto', boxShadow: '0 12px 40px rgba(0,0,0,0.25)',
};
const header = {
  background: '#1D2C5F', padding: '14px 18px',
  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
};
const closeBtn = { background: 'none', border: 'none', color: '#fff', fontSize: 24, cursor: 'pointer', lineHeight: 1 };
const body = { padding: '18px' };
const label = { display: 'block', fontWeight: 600, fontSize: 13, margin: '12px 0 4px' };
const input = {
  width: '100%', padding: '8px 10px', border: '1px solid #ccc', borderRadius: 6,
  fontSize: 14, boxSizing: 'border-box', fontFamily: 'inherit',
};
const toggleBase = { flex: 1, padding: '8px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 14, fontWeight: 600 };
const toggleOn = { ...toggleBase, background: '#1D2C5F', color: '#fff', border: '1px solid #1D2C5F' };
const toggleOff = { ...toggleBase, background: '#fff', color: '#374151', border: '1px solid #ccc' };
const primaryBtn = { background: '#1D2C5F', color: '#fff', border: 'none', borderRadius: 6, padding: '10px 18px', fontWeight: 700, cursor: 'pointer' };
const secondaryBtn = { background: '#fff', color: '#374151', border: '1px solid #ccc', borderRadius: 6, padding: '10px 16px', cursor: 'pointer' };
